import React from 'react';

import { Grid, Skeleton, Typography } from '@mui/material';

import { DateFormatter } from '@waypoint/react-formatters';

type Props = {
  children: JsxNode;
};
export default function AdminDictionaryList({ children }: Props) {
  return (
    <Grid container component="dl" spacing={2}>
      {children}
    </Grid>
  );
}

type PairProps = {
  label: string;
  value: JsxNode | undefined | null | boolean | string | Date;
};
export function Pair({ label, value }: PairProps) {
  const renderValue = () => {
    if (value === undefined) {
      return <Skeleton width={200} />;
    }
    if (typeof value === 'boolean') {
      return value ? 'Enabled' : 'Disabled';
    }
    if (typeof value === 'string') {
      return value;
    }
    if (value instanceof Date) {
      return <DateFormatter value={value} />;
    }
    if (value === null) {
      return ' - ';
    }
    return value;
  };

  return (
    <>
      <Grid item xs={12} sm={2} component="dt">
        <Typography fontWeight="bold">{label}</Typography>
      </Grid>
      <Grid item xs={12} sm={10} component="dd">
        {renderValue()}
      </Grid>
    </>
  );
}
